import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataTablesModule } from 'angular-datatables';
import { LayoutModule } from 'app/layout/layout.module';
import { CostEstimatorModule } from '../cost-estimator/cost-estimator.module';
import {
    DdAgreementBetaDialogModule,
} from '../delivery-defense/dd-agreement-beta-dialog/dd-agreement-beta-dialog.module';
import { EInvoiceSignUpModule } from '../shared/components/e-invoice-sign-up/e-invoice-sign-up.module';
import { ImageRotatorModule } from '../shared/components/image-rotator/image-rotator.module';
import { NotificationsModule } from '../shared/components/notifications/notifications.module';
import { S3FileDownloaderModule } from '../shared/components/s3-file-downloader/s3-file-downloader.module';
import { SharedModule } from '../shared/shared.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardGuard } from './dashboard.guard';
import { DashboardResolver } from './dashboard.resolver';
import { DashboardRoutingModule } from './dashboard.routing.module';
import { DefencePopupComponent } from './defence-popup/defence-popup.component';

@NgModule({
    imports: [
        DashboardRoutingModule,
        CommonModule,
        SharedModule,
        LayoutModule,
        EInvoiceSignUpModule,
        CostEstimatorModule,
        DataTablesModule,
        S3FileDownloaderModule,
        ImageRotatorModule,
        NotificationsModule,
        DdAgreementBetaDialogModule,
        NgOptimizedImage,
    ],
    declarations: [
        DashboardComponent,
        DefencePopupComponent,
    ],
    providers: [
        DashboardResolver,
        DashboardGuard,
    ],
})
export class DashboardModule {
}
